import React from "react";
import PricingDashboard from "../../../components/marketing/reseller/pricing-dashboard";

// The reseller's whole world is Convo Marketing pricing — per the explicit
// requirement, the reseller role has no access to CRM/Automate/other
// modules, so this dashboard IS the pricing view rather than one tab among
// several. See components/marketing/reseller/pricing-dashboard.tsx for the
// (currently hardcoded) data and the Global Admin read-only counterpart at
// views/global-admin-pages/convo-marketing.
const ResellerDashboard: React.FC = () => <PricingDashboard editable />;

export default ResellerDashboard;
